//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.PersonalizationData

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The event model
* 
* @param bundleId The bundle id
* @param bundleProductId The bundle product id
* @param cartItemId The cart item id
* @param eventId The event id
* @param eventTitle The localized title of the event
* @param isPersonalized Defines if the product is personalized
* @param productId The product id
* @param productTitle The localized title of the product
* @param quantity The quantity of the product
* @param description The localized description of the product
* @param personalizationData The personalization config
*/
@Serializable

data class BundleItem (


      /* The bundle id */
    @SerialName(value = "bundleId") @Required val bundleId: kotlin.Int,


      /* The bundle product id */
    @SerialName(value = "bundleProductId") @Required val bundleProductId: kotlin.Int,


      /* The cart item id */
    @SerialName(value = "cartItemId") @Required val cartItemId: kotlin.uuid.Uuid,


      /* The event id */
    @SerialName(value = "eventId") @Required val eventId: kotlin.Int,


      /* The localized title of the event */
    @SerialName(value = "eventTitle") @Required val eventTitle: kotlin.String,


      /* Defines if the product is personalized */
    @SerialName(value = "isPersonalized") @Required val isPersonalized: kotlin.Boolean,


      /* The product id */
    @SerialName(value = "productId") @Required val productId: kotlin.Int,


      /* The localized title of the product */
    @SerialName(value = "productTitle") @Required val productTitle: kotlin.String,


      /* The quantity of the product */
    @SerialName(value = "quantity") @Required val quantity: kotlin.Int = 0,


      /* The localized description of the product */
    @SerialName(value = "description") val description: kotlin.String? = null,


      /* The personalization config */
    @SerialName(value = "personalizationData") val personalizationData: kotlin.collections.List<PersonalizationData>? = null


) {




  }

